import './style.scss';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { withLanguageLocale } from '../../services/Helper';
import { Button as MainButton } from '@studygo/frontend-components';

const Button = (props) => {
	const { dataName, disabled, disabledDropdownItem, link, loading, onClick, tabIndex } =
		props || {};

	const linkWrapper = (content, className) => (
		<Link
			tabIndex={tabIndex}
			to={withLanguageLocale(link)}
			className={className}
			onClick={disabled || loading || disabledDropdownItem ? undefined : onClick}
			data-name={dataName}
		>
			{content}
		</Link>
	);

	return (
		<MainButton
			{...props}
			customWrapComponent={
				link ? (content, className) => linkWrapper(content, className) : undefined
			}
		/>
	);
};

Button.defaultProps = {
	tabIndex: -1,
	dataName: '',
};

Button.propTypes = {
	disabled: PropTypes.bool,
	link: PropTypes.string,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	dataName: PropTypes.string,
};

export default memo(Button);
